'use client'
import { useEffect, useState } from 'react'

import { useViewport } from '@/components/findex-connect/hooks/useViewport'
import { Section, useThemeStore } from '@/components/findex-connect/store/ThemeStore'

type StickyNavProps = {
  sections: Section[]
}

export const StickyNav: React.FC<StickyNavProps> = ({ sections }) => {
  const [isVisible, setIsVisible] = useState(false)
  const { viewportWidth } = useViewport()
  const activeSection = useThemeStore((state) => state.activeSection)
  const isMobileFormVisible = useThemeStore((state) => state.isMobileFormVisible)

  useEffect(() => {
    if (activeSection !== 'overview') {
      setIsVisible(true)
    } else {
      setIsVisible(false)
    }
  }, [activeSection, sections])

  return (
    <div
      id="STICKYNAV"
      className={
        `STICKYNAV left-0 z-[999999] hidden h-18 w-full border-b border-black/10 bg-white px-4 transition-all duration-750 ease-in-out md:fixed md:block ` +
        (isVisible ? 'visible top-0' : '-top-20')
      }
    >
      <div className="STICKYNAV-INNER max-w-container mx-auto flex h-full items-center justify-center lg:justify-start">
        {sections?.map((section, index) => {
          return (
            <button
              key={section}
              className={
                `tab-outline-primary-inset hover:text-primary-hover hover:border-b-primary-hover lg:text-md flex h-full cursor-pointer content-center items-center p-2 text-center text-sm lg:p-3 xl:text-lg ` +
                (activeSection === section
                  ? '!text-primary-light border-primary-light border-b'
                  : 'text-prominent border-b border-black/0')
              }
              onClick={() => {
                scrollTo({
                  top:
                    index === 0
                      ? 0
                      : (viewportWidth > 1023 ? 800 : 0) +
                        (document.getElementById(section)?.offsetTop || 0),
                  behavior: 'smooth',
                })
              }}
            >
              {section.charAt(0).toUpperCase() +
                section.replaceAll('-', ' ').replaceAll('findex', 'Findex?').slice(1)}
            </button>
          )
        })}

        <button
          className="bg-primary-dark tab-outline-primary hover:bg-primary-hover md:text-md ml-auto hidden cursor-pointer rounded-full px-4 py-2 text-xs font-semibold text-white transition-all duration-150 ease-in-out md:block lg:px-5 lg:text-lg"
          onClick={() => {
            if (viewportWidth > 1024) {
              window.scrollTo({
                top: 0,
                behavior: 'smooth',
              })
            } else {
              if (!isMobileFormVisible) {
                useThemeStore.setState({
                  isMobileFormVisible: true,
                })
              }
            }
          }}
        >
          Connect your client
        </button>
      </div>
    </div>
  )
}
